import type { ComponentProps } from 'react'
import { cn } from '@/lib/cn'

export function Input({ className, type = 'text', ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn(
        'h-10 w-full min-w-0 rounded-md border border-border-strong bg-surface-raised px-3 text-sm text-ink transition-colors outline-none placeholder:text-ink-subtle',
        'focus-visible:border-ink focus-visible:ring-4 focus-visible:ring-focus/25 focus-visible:outline-none',
        'aria-invalid:border-danger aria-invalid:focus-visible:ring-danger/20',
        'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:opacity-70',
        className,
      )}
      {...props}
    />
  )
}
